export default __webpack_public_path__ + "static/media/socialtree.0f711b70.png";